import { createSlice } from '@reduxjs/toolkit';
import { createControl } from '../../../../../domain/validation/validation';
import { IFormControl } from '../../../../../ui/forms/interfaces';
import { default as cloneDeep } from 'lodash/cloneDeep';

interface INewCreditCardState{

    bloxController: any;

    // cart holder name control
    nameOnCardControl: IFormControl,

    // BrigerPay token that is received from js API
    newCreditCardToken: string,

    rememberMe: boolean,
    cvvInfoPopupShown: boolean,
}

/**
 * initial state
 */
const initialState: INewCreditCardState = {
    bloxController: null,

    nameOnCardControl: createControl('nameOnCard', '', {
        required: true,
        regex: '^[^<>]*$',
        regexMessage: 'The card holder name includes invalid characters.',
    }),

    newCreditCardToken: '',

    rememberMe: true,
    cvvInfoPopupShown: false,
};

const newCreditCardSlice = createSlice({
    name: 'new-credit-card',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },

        setControl(state, action) {
            return {
                ...state,
                [action.payload.controlName]: cloneDeep(action.payload.control),
            }
        },
    }
});

export default newCreditCardSlice;